<template lang="html">
  <div class="batch-status">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('titleBatchStatus','titleBatchStatus') }}</h6>
          <div class="element-box">
            <div>
              <div class="element-info">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8">
                    <div class="element-info-with-icon">
                      <div class="element-info-icon">
                        <span class="os-icon os-icon-search2"></span>
                      </div>
                      <div class="element-info-text">
                        <h5 class="element-inner-header">{{ t('titleBatchStatusSearch','titleBatchStatusSearch') }}</h5>
                        <div class="element-inner-desc">{{ t('descBatchStatusSearch','descBatchStatusSearch') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4">
                    <i id="batchToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                  </div>
                </div>
              </div>
              <b-collapse id="search" >
                <form v-on:submit.prevent="requestBatchStatus">
                  <div class="col-lg-12 row">
                    <div class="col-lg-2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-id" class="d-block text-center">{{t('searchLabelBatchId','searchLabelBatchId') }}</label>
                          <input id="batch-id" v-model="batchListRequest.batch_id" class="form-control text-center" :placeholder="1" type="text">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-ref" class="d-block text-center">{{t('searchLabelBatchRef','searchLabelBatchRef') }}</label>
                          <input id="batch-ref" v-model="batchListRequest.batch_ref" class="form-control text-center" :placeholder="t('searchLabelBatchRef','searchLabelBatchRef')" type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-after" class="d-block text-center">{{t('searchLabelBatchDAfter','searchLabelBatchDAfter') }}</label>
                          <datePicker id="batch-after" v-model="batchListRequest.upload_after" class="form-control text-center" :config="datePickerAfterConfig" :placeholder="t('searchLabelBatchDAfter','searchLabelBatchDAfter')">
                          </datePicker>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-before" class="d-block text-center">{{ t('searchLabelBatchDBefore','searchLabelBatchDBefore') }}</label>
                          <datePicker id="batch-before" v-model="batchListRequest.upload_before" class="form-control text-center" :config="datePickerBeforeConfig" :placeholder="t('searchLabelBatchDBefore','searchLabelBatchDBefore')">
                          </datePicker>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <!--<label for="batch-type" class="d-block text-center">{{t('searchLabelBatchType','searchLabelBatchType') }}</label>-->
                          <b-dropdown id="dropdown-status" :text="t('searchLabelBatchType','searchLabelBatchType')" ref="dropdown" class="m-2 pt-3">
                            <b-dropdown-form class="p-2 dropdown-withform">
                              <div>
                                <b-form-input
                                  type="text"
                                  size="sm"
                                  :placeholder="'Filter'"
                                  v-model="typeListFilter"
                                ></b-form-input>
                              </div>
                              <div class="d-flex justify-content-between pt-2">
                                <span @click="selectAllVisibleFiltersInList('type')" class="showhand">
                                  <fontAwesomeIcon :icon="['fa', 'check']" size="1x" class="text-primary" />
                                  {{t('checkAllSelectorText','checkAllSelectorText')}}
                                </span>
                                <span @click="deselectVisibleFilterList('type')" class="showhand">
                                  <fontAwesomeIcon :icon="['fa', 'times']" size="1x" class="text-primary" />
                                  {{t('uncheckAllSelectorText','uncheckAllSelectorText')}}
                                </span>
                              </div>
                              <hr>
                              <b-form-checkbox-group v-model="batch_type" name="type" class="d-flex flex-column text-capitalize">
                                <b-form-checkbox v-for="batchType in batchTypes" :value="batchType.id" :key="batchType.id" class="type-item" >{{ batchType.name }}</b-form-checkbox>
                              </b-form-checkbox-group>
                            </b-dropdown-form>
                          </b-dropdown>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <!--<label for="batch-status" class="d-block text-center" >{{t('searchLabelBatchStatus','searchLabelBatchStatus') }}</label>-->
                          <b-dropdown id="dropdown-status" :text="t('searchLabelBatchStatus','searchLabelBatchStatus')" ref="dropdown" class="m-2 pt-3">
                            <b-dropdown-form class="p-2 dropdown-withform">
                              <div>
                                <b-form-input
                                  type="text"
                                  size="sm"
                                  :placeholder="'Filter'"
                                  v-model="statusListFilter"
                                ></b-form-input>
                              </div>
                              <div class="d-flex justify-content-between pt-2">
                                <span @click="selectAllVisibleFiltersInList('status')" class="showhand">
                                  <fontAwesomeIcon :icon="['fa', 'check']" size="1x" class="text-primary" />
                                  {{t('checkAllSelectorText','checkAllSelectorText')}}
                                </span>
                                <span @click="deselectVisibleFilterList('status')" class="showhand">
                                  <fontAwesomeIcon :icon="['fa', 'times']" size="1x" class="text-primary" />
                                  {{t('uncheckAllSelectorText','uncheckAllSelectorText')}}
                                </span>
                              </div>
                              <hr>
                              <b-form-checkbox-group v-model="batch_status" name="status" class="d-flex flex-column text-capitalize">
                                <b-form-checkbox v-for="status in batchStatuses" :value="status.status" :key="status.id" class="status-item" >{{ status.status }}</b-form-checkbox>
                              </b-form-checkbox-group>
                            </b-dropdown-form>
                          </b-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 row justify-content-between">
                    <div class="col-lg-2">
                      <b-input-group class="form-group col-lg-12">
                        <b-input-group-prepend>
                          <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                        </b-input-group-prepend>
                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                      </b-input-group>
                    </div>
                    <div class="form-group col-lg-4">
                      <button class="btn btn-primary float-right ml-2" type="submit" >{{ t('searchButtonText','searchButtonText') }}</button>
                      <button class="btn btn-secondary float-right" @click="resetSearch()">{{ t('resetButtonText','resetButtonText') }}</button>
                    </div>
                  </div>
                </form>
              </b-collapse>
            </div>
          </div>
          <div class="element-box">
            <div class="element-box-tp">
              <b-tabs v-model="tabIndex" content-class="mt-3">
                <b-tab :title="t('tabTitleStartReports', 'tabTitleStartReports')" active>
                  <div class="controls-below-table width-control">
                    <div v-if="items" class="table-records-info">
                      <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                      <p v-else>{{totalRows}} {{ t('entriesFoundRecordsLabel','entriesFoundRecordsLabel') }}</p>
                    </div>
                    <div>
                      <b-pagination v-if="items" ref="paginationStartTop" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                      </b-pagination>
                    </div>
                  </div>
                  <div v-if="items" class="table-responsive width-control" :class="{ 'table-height-fix': (items.length > 5) }">
                    <b-table v-if="tabIndex === 0" id="start-reports" striped hover bordered foot-clone responsive class="mt-3" :busy.sync="isBusy" :items="items" :fields="startFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                    :total-rows="totalRows" per-page="0" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" :show-empty="rowEmpty" :summary="summary" :tbody-tr-class="rowClass" tfoot-tr-class="sticky-footer" sticky-header no-border-collapse>
                      <template v-slot:head(id)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(reference)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_dataxferred_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_emailed_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_faxed_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_posted_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_online_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(deleted_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_total_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <!--
                      <template v-slot:head(start_failed_dataxferred_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_failed_emailed_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_failed_faxed_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(start_failed_total_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>-->
                      <template class="busy-row" v-slot:table-busy>
                        <div class="vld-parent spinner-row text-center">
                          <loading :active.sync="isBusy"
                          :can-cancel="false"
                          :color="'#047bf8'"
                          :loader="'dots'"
                          :is-full-page="false"></loading>
                        </div>
                      </template>
                      <template v-slot:empty="scope">
                        <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
                      </template>
                      <template v-slot:cell(id)="row">
                        <span v-if="Object.keys(row.item.sub_batch).length">
                          <fontAwesomeIcon v-if="row.detailsShowing" @click="row.toggleDetails" :icon="['fas', 'minus']" class="text-primary showhand mr-2" size="1x"/>
                          <fontAwesomeIcon v-else @click="row.toggleDetails" :icon="['fas', 'plus']" class="text-primary showhand mr-2" size="1x"/>
                        </span>
                        <span v-if="row.item.test_mode" class="text-danger">{{ row.item.id }}</span>
                        <span v-else>{{ row.item.id }}</span>
                      </template>
                      <template v-slot:cell(reference)="data">
                        <span v-if="Object.keys(data.item.sub_batch).length"><router-link :to="{name: 'documents', props: { id: data.item.id}}" :title="`${t('uploadedOn', 'uploadedOn')} ${data.item.added_on}`">{{ data.item.reference | trimBatchReference(batchRefTrim) }}</router-link></span>
                        <span v-else><router-link :to="{name: 'batch', props: { id: data.item.id}}" :title="`${t('uploadedOn', 'uploadedOn')} ${data.item.added_on}`">{{ data.item.reference | trimBatchReference(batchRefTrim) }}</router-link></span>
                      </template>
                      <template v-slot:cell(start_dataxferred_docs)="data">
                        <span>{{ data.item.total.start_dataxferred_docs.value }} </span>
                        <span>({{ data.item.total.start_dataxferred_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(start_emailed_docs)="data">
                        <span>{{ data.item.total.start_emailed_docs.value }} </span>
                        <span>({{ data.item.total.start_emailed_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(start_faxed_docs)="data">
                        <span>{{ data.item.total.start_faxed_docs.value }} </span>
                        <span>({{ data.item.total.start_faxed_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(start_posted_docs)="data">
                        <span>{{ data.item.total.start_posted_docs.value }} </span>
                        <span>({{ data.item.total.start_posted_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(start_online_docs)="data">
                        <span>{{ data.item.total.start_online_docs.value }} </span>
                        <span>({{ data.item.total.start_online_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(deleted_docs)="data">
                        <span>{{ data.item.total.deleted_docs.value }} </span>
                        <span>({{ data.item.total.deleted_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(start_total_docs)="data">
                        <span>{{ data.item.total.start_total_docs.value }} </span>
                        <span>({{ data.item.total.start_total_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(start_failed_dataxferred_docs)="data">
                        <span></span>
                      </template>
                      <template v-slot:cell(start_failed_emailed_docs)="data">
                        <span></span>
                      </template>
                      <template v-slot:cell(start_failed_faxed_docs)="data">
                        <span></span>
                      </template>
                      <template v-slot:cell(start_failed_total_docs)="data">
                        <span></span>
                      </template>
                      <template v-slot:row-details="row">
                        <SubStatus v-if="Object.keys(row.item.sub_batch).length" :items="row.item.sub_batch" :tabIndex="tabIndex"/>
                      </template>
                      <template v-slot:foot(id)="data">
                        <span>{{ t('startText', 'startText') }}</span>
                      </template>
                      <template v-slot:foot(reference)="data">
                        <span>{{ t('pageSummaryText', 'pageSummaryText') }}</span>
                      </template>
                      <template v-slot:foot(start_dataxferred_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.start_dataxferred_docs.value }} </span>
                        <span>({{ summary.start_dataxferred_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(start_emailed_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.start_emailed_docs.value }} </span>
                        <span>({{ summary.start_emailed_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(start_faxed_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.start_faxed_docs.value }} </span>
                        <span>({{ summary.start_faxed_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(start_posted_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.start_posted_docs.value }} </span>
                        <span>({{ summary.start_posted_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(start_online_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.start_online_docs.value }} </span>
                        <span>({{ summary.start_online_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(deleted_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.deleted_docs.value }} </span>
                        <span>({{ summary.deleted_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(start_total_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.start_total_docs.value }} </span>
                        <span>({{ summary.start_total_docs.percentage }}%)</span>
                      </template>
                      <!--
                      <template v-slot:foot(start_failed_dataxferred_docs)="data">
                      </template>
                      <template v-slot:foot(start_failed_emailed_docs)="data">
                      </template>
                      <template v-slot:foot(start_failed_faxed_docs)="data">
                      </template>
                      <template v-slot:foot(start_failed_total_docs)="data">
                      </template>
                    -->
                    </b-table>
                  </div>
                  <div class="controls-below-table pt-4 width-control">
                    <div v-if="items" class="table-records-info">
                      <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                      <p v-else class="mb-0">{{totalRows}} {{ t('entriesFoundRecordsLabel','entriesFoundRecordsLabel') }}</p>
                    </div>
                    <fieldset class="d-flex mt-0 border">
                      <legend class="mb-0 text-secondary"> {{ t('subBatchStatusColourGuide', 'subBatchStatusColourGuide') }}</legend>
                      <ul class="no-list-style">
                        <li class="d-inline">
                          <span class="d-inline-block colour-sample highlight-yellow align-middle"> </span>
                          <span class="px-1 align-middle">{{ t('proofLabel', 'proofLabel') }}</span>
                        </li>
                        <li class="d-inline">
                          <span class="d-inline-block colour-sample highlight-green align-middle"></span>
                          <span class="px-1 align-middle">{{ t('approvedLabel', 'approvedLabel') }}</span>
                        </li>
                        <li class="d-inline">
                          <span class="d-inline-block colour-sample highlight-grey align-middle"></span>
                          <span class="px-1 align-middle">{{ t('uploadedLabel', 'uploadedLabel') }}</span>
                        </li>
                        <li class="d-inline">
                          <span class="d-inline-block colour-sample highlight-red align-middle"></span>
                          <span class="px-1 align-middle">{{ t('rejectedLabel', 'rejectedLabel') }}</span>
                        </li>
                      </ul>
                    </fieldset>
                    <div>
                      <b-pagination v-if="items" ref="paginationStartBottom" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                      </b-pagination>
                    </div>
                  </div>
                </b-tab>
                <b-tab :title="t('tabTitleFinalReports', 'tabTitleFinalReports')">
                  <div class="controls-below-table width-control">
                    <div v-if="items" class="table-records-info">
                      <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                      <p v-else>{{totalRows}} {{ t('entriesFoundRecordsLabel','entriesFoundRecordsLabel') }}</p>
                    </div>
                    <div>
                      <b-pagination v-if="items" ref="paginationFinalTop" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                      </b-pagination>
                    </div>
                  </div>
                  <div v-if="items" class="table-responsive width-control" :class="{ 'table-height-fix': (items.length > 5) }">
                    <b-table v-if="tabIndex === 1" id="final-reports" striped hover bordered foot-clone responsive class="mt-3" :busy.sync="isBusy" :items="items" :fields="finalFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                    :total-rows="totalRows" per-page="0" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" :show-empty="rowEmpty" :tbody-tr-class="rowClass" tfoot-tr-class="sticky-footer" sticky-header no-border-collapse>
                      <template v-slot:head(id)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(reference)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_dataxferred_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_emailed_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_faxed_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_posted_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_online_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(deleted_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_total_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_failed_dataxferred_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_failed_emailed_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_failed_faxed_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template v-slot:head(final_failed_total_docs)="data">
                        <span >{{ t(data.label, data.label) }}</span>
                      </template>
                      <template class="busy-row" v-slot:table-busy>
                        <div class="vld-parent spinner-row text-center">
                          <loading :active.sync="isBusy"
                          :can-cancel="false"
                          :color="'#047bf8'"
                          :loader="'dots'"
                          :is-full-page="false"></loading>
                        </div>
                      </template>
                      <template v-slot:empty="scope">
                        <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
                      </template>
                      <template v-slot:cell(id)="row">
                        <span v-if="Object.keys(row.item.sub_batch).length">
                          <fontAwesomeIcon v-if="!row.detailsShowing" @click="row.toggleDetails" :icon="['fas', 'plus']" class="text-primary showhand mr-2" size="1x"/>
                          <fontAwesomeIcon v-else @click="row.toggleDetails" :icon="['fas', 'minus']" class="text-primary showhand mr-2" size="1x"/>
                        </span>
                        <span v-if="row.item.test_mode" class="text-danger">{{ row.item.id }}</span>
                        <span v-else>{{ row.item.id }}</span>
                      </template>
                      <template v-slot:cell(reference)="data">
                        <span v-if="Object.keys(data.item.sub_batch).length"><router-link :to="{name: 'documents', props: { id: data.item.id}}" :title="`${t('uploadedOn', 'uploadedOn')} ${data.item.added_on}`">{{ data.item.reference | trimBatchReference(batchRefTrim) }}</router-link></span>
                        <span v-else><router-link :to="{name: 'batch', props: { id: data.item.id}}" :title="`${t('uploadedOn', 'uploadedOn')} ${data.item.added_on}`">{{ data.item.reference | trimBatchReference(batchRefTrim) }}</router-link></span>
                      </template>
                      <template v-slot:cell(final_dataxferred_docs)="data">
                        <span>{{ data.item.total.final_dataxferred_docs.value }} </span>
                        <span>({{ data.item.total.final_dataxferred_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_emailed_docs)="data">
                        <span>{{ data.item.total.final_emailed_docs.value }} </span>
                        <span>({{ data.item.total.final_emailed_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_faxed_docs)="data">
                        <span>{{ data.item.total.final_faxed_docs.value }} </span>
                        <span>({{ data.item.total.final_faxed_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_posted_docs)="data">
                        <span>{{ data.item.total.final_posted_docs.value }} </span>
                        <span>({{ data.item.total.final_posted_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_online_docs)="data">
                        <span>{{ data.item.total.final_online_docs.value }} </span>
                        <span>({{ data.item.total.final_online_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(deleted_docs)="data">
                        <span>{{ data.item.total.deleted_docs.value }} </span>
                        <span>({{ data.item.total.deleted_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_total_docs)="data">
                        <span>{{ data.item.total.final_total_docs.value }} </span>
                        <span>({{ data.item.total.final_total_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_failed_dataxferred_docs)="data">
                        <span>{{ data.item.total.final_failed_dataxferred_docs.value }} </span>
                        <span>({{ data.item.total.final_failed_dataxferred_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_failed_emailed_docs)="data">
                        <span>{{ data.item.total.final_failed_emailed_docs.value }} </span>
                        <span>({{ data.item.total.final_failed_emailed_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_failed_faxed_docs)="data">
                        <span>{{ data.item.total.final_failed_faxed_docs.value }} </span>
                        <span>({{ data.item.total.final_failed_faxed_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(final_failed_total_docs)="data">
                        <span>{{ data.item.total.final_failed_total_docs.value }} </span>
                        <span>({{ data.item.total.final_failed_total_docs.percentage}}%)</span>
                      </template>
                      <template v-slot:cell(added_on)="data">
                        <span>{{ t('uploadedOn', 'uploadedOn') }} </span> <span>{{ data.item.added_on | clientDateFormat(datePickerFormat) }}</span>
                      </template>
                      <template v-slot:row-details="row">
                        <SubStatus v-if="Object.keys(row.item.sub_batch).length" :items="row.item.sub_batch" :tabIndex="tabIndex"/>
                      </template>
                      <template v-slot:foot(id)="data">
                        <span>{{ t('finalText', 'finalText') }}</span>
                      </template>
                      <template v-slot:foot(reference)="data">
                        <span>{{ t('pageSummaryText', 'pageSummaryText') }}</span>
                      </template>
                      <template v-slot:foot(final_dataxferred_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_dataxferred_docs.value }} </span>
                        <span>({{ summary.final_dataxferred_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(final_emailed_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_emailed_docs.value }} </span>
                        <span>({{ summary.final_emailed_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(final_faxed_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_faxed_docs.value }} </span>
                        <span>({{ summary.final_faxed_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(final_posted_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_posted_docs.value }} </span>
                        <span>({{ summary.final_posted_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(final_online_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_online_docs.value }} </span>
                        <span>({{ summary.final_online_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(deleted_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.deleted_docs.value }} </span>
                        <span>({{ summary.deleted_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(final_total_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_total_docs.value }} </span>
                        <span>({{ summary.final_total_docs.percentage }}%)</span>
                      </template>
                      <template v-slot:foot(final_failed_dataxferred_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_failed_dataxferred_docs.value }} </span>
                        <span>({{ summary.final_failed_dataxferred_docs.percentage }}%) ({{ t('failedlLabel', 'failedLabel') }})</span>
                      </template>
                      <template v-slot:foot(final_failed_emailed_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_failed_emailed_docs.value }} </span>
                        <span>({{ summary.final_failed_emailed_docs.percentage }}%) ({{ t('failedlLabel', 'failedLabel') }})</span>
                      </template>
                      <template v-slot:foot(final_failed_faxed_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_failed_faxed_docs.value }} </span>
                        <span>({{ summary.final_failed_faxed_docs.percentage }}%) ({{ t('failedlLabel', 'failedLabel') }})</span>
                      </template>
                      <template v-slot:foot(final_failed_total_docs)="data">
                        <span>{{ t('totalLabel', 'totalLabel') }}: {{ summary.final_failed_total_docs.value }} </span>
                        <span>({{ summary.final_failed_total_docs.percentage }}%) ({{ t('failedlLabel', 'failedLabel') }})</span>
                      </template>
                    </b-table>
                  </div>
                  <div class="controls-below-table pt-4 width-control">
                    <div class="table-records-info" v-if="items">
                      <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                      <p v-else class="mb-0">{{totalRows}} {{ t('entriesFoundRecordsLabel','entriesFoundRecordsLabel') }}</p>
                    </div>
                    <fieldset class="d-flex mt-0 border">
                      <legend class="mb-0 text-secondary"> {{ t('subBatchStatusColourGuide', 'subBatchStatusColourGuide') }}</legend>
                      <ul class="no-list-style">
                        <li class="d-inline">
                          <span class="d-inline-block colour-sample highlight-yellow align-middle"> </span>
                          <span class="px-1 align-middle">{{ t('proofLabel', 'proofLabel') }}</span>
                        </li>
                        <li class="d-inline">
                          <span class="d-inline-block colour-sample highlight-green align-middle"></span>
                          <span class="px-1 align-middle">{{ t('approvedLabel', 'approvedLabel') }}</span>
                        </li>
                        <li class="d-inline">
                          <span class="d-inline-block colour-sample highlight-grey align-middle"></span>
                          <span class="px-1 align-middle">{{ t('uploadedLabel', 'uploadedLabel') }}</span>
                        </li>
                        <li class="d-inline">
                          <span class="d-inline-block colour-sample highlight-red align-middle"></span>
                          <span class="px-1 align-middle">{{ t('rejectedLabel', 'rejectedLabel') }}</span>
                        </li>
                      </ul>
                    </fieldset>
                    <div>
                      <b-pagination v-if="items" ref="paginationFinalBottom" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                      </b-pagination>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
            <br>
            <div class="d-flex justify-content-between">
              <button class="btn btn-secondary" @click="routeBackToManageBatches()">{{ t('BackToManageBatchesButtonText','BackToManageBatchesButtonText') }}</button>
              <button class="btn btn-secondary" >{{ t('CSVExportButtonText','CSVExportButtonText') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import Loading from 'vue-loading-overlay'
import SubStatus from '@/components/SubStatus.vue'

import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
name: 'batch_status',
//these functions and values are inheritable from this component
provide() {
  return {
      batchRefTrim: this.batchRefTrim,
      datePickerFormat: this.datePickerFormat
  }
},
data() {
  return {
    tabIndex: 0,
    items: [],
    subOpen: true,
    summary: {
      'deleted_docs' : {},
      'final_dataxferred_docs' : {},
      'final_emailed_docs' : {},
      'final_failed_emailed_docs' : {},
      'final_failed_faxed_docs' : {},
      'final_faxed_docs' : {},
      'final_online_docs' : {},
      'final_posted_docs' : {},
      'final_total_docs' : {},
      'start_dataxferred_docs' : {},
      'start_emailed_docs' : {},
      'start_faxed_docs' : {},
      'start_online_docs' : {},
      'start_posted_docs' : {},
      'start_total_docs' : {}
    },
    startFields: [
      {key: 'id', label:'tableHeadBatchNumber', sortable:true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'reference', label: 'tableHeadBatchReference', thClass: 'standard-th-width-xl', tdClass: 'standard-cell-width-xl'},
      {key: 'start_dataxferred_docs', label: 'tableHeadDocsDataxferred', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'start_emailed_docs', label: 'tableHeadDocsEmailed', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
      {key: 'start_faxed_docs', label:'tableHeadDocsFaxed', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
      {key: 'start_posted_docs', label: 'tableHeadDocsPosted', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'start_online_docs', label: 'tableHeadDocsOnline', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'deleted_docs', label: 'tableHeadDocsDeleted', sortable: true,  thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'start_total_docs', label:'tableHeadDocsTotal', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      //{key: 'start_failed_dataxferred_docs', label: 'tableHeadDocsFailedDataxferred', thClass: 'standard-th-width-small', tdClass: ['standard-cell-width-small', 'text-center']},
      //{key: 'start_failed_emailed_docs', label: 'tableHeadDocsFailedEmail', thClass: 'standard-th-width-small', tdClass: ['standard-cell-width-small', 'text-center']},
      //{key: 'start_failed_faxed_docs', label: 'tableHeadDocsFailedFax', thClass: 'standard-th-width-small', tdClass: ['standard-cell-width-small', 'text-center']},
      //{key: 'start_failed_total_docs', label: 'tableHeadDocsFailedTotal', thClass: 'standard-th-width-small', tdClass: ['standard-cell-width-small', 'text-center']}
    ],
    finalFields: [
      {key: 'id', label:'tableHeadBatchNumber', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'reference', label: 'tableHeadBatchReference', thClass: 'standard-th-width-xl', tdClass: 'standard-cell-width-xl'},
      {key: 'final_dataxferred_docs', label: 'tableHeadDocsDataxferred', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
      {key: 'final_emailed_docs', label: 'tableHeadDocsEmailed', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
      {key: 'final_faxed_docs', label: 'tableHeadDocsFaxed', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
      {key: 'final_posted_docs', label: 'tableHeadDocsPosted', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
      {key: 'final_online_docs', label: 'tableHeadDocsOnline', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: (value, key, item) => (item.highlighted.includes(key)) ? ['highlight-red', 'standard-cell-width-small', 'text-center'] : ['standard-cell-width-small', 'text-center']},
      {key: 'deleted_docs', label: 'tableHeadDocsDeleted', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'final_total_docs', label: 'tableHeadDocsTotal', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'final_failed_dataxferred_docs', label: 'tableHeadDocsFailedDataxferred', thClass: 'standard-th-width-small', tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'final_failed_emailed_docs', label: 'tableHeadDocsFailedEmail', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'final_failed_faxed_docs', label: 'tableHeadDocsFailedFax', sortable: true, thClass: ['standard-th-width-small', 'showhand'], tdClass: ['standard-cell-width-small', 'text-center']},
      {key: 'final_failed_total_docs', label: 'tableHeadDocsFailedTotal', thClass: 'standard-th-width-small', tdClass: ['standard-cell-width-small', 'text-center']}
    ],
    datePickerAfterConfig: {
      icons: {
        time: 'os-icon os-icon-calendar-time',
        date: 'os-icon os-icon-basic-2-259-calendar',
        up: 'os-icon os-icon-chevron-up',
        down: 'os-icon os-icon-chevron-down',
        previous: 'os-icon os-icon-chevron-left',
        next: 'os-icon os-icon-chevron-right',
        clear: 'os-icon os-icon-trash',
        close: 'os-icon os-icon-cancel-circle'
      },
      showClear: true
    },
    datePickerBeforeConfig: {
      icons: {
        time: 'os-icon os-icon-calendar-time',
        date: 'os-icon os-icon-basic-2-259-calendar',
        up: 'os-icon os-icon-chevron-up',
        down: 'os-icon os-icon-chevron-down',
        previous: 'os-icon os-icon-chevron-left',
        next: 'os-icon os-icon-chevron-right',
        clear: 'os-icon os-icon-trash',
        close: 'os-icon os-icon-cancel-circle'
      },
      minDate: moment('1979-01-01', this.datePickerFormat),
      showClear: true
    },
    statusListFilter: '',
    typeListFilter: '',
    reportType: 'start',
    currentPage: 1,
    perPage: 20,
    batch_type: [],
    batch_status: [],
    sortBy: null,
    sortDesc: false,
    pageOptions: [10, 20, 50, 100],
    filter: null,
    isBusy: false,
    rowEmpty: false,
    totalRows: null,
    filteredRows: '',
    maxDate: '',
    minDate: '',
    batchListRequest: {
      page: this.$route.query.page,
      per_page: this.$route.query.per_page,
      batch_id: this.$route.query.batch_id,
      batch_ref: this.$route.query.batch_ref,
      batch_type: this.$route.query.batch_type,
      batch_status: this.$route.query.batch_status,
      upload_after : this.$route.query.upload_after,
      upload_before : this.$route.query.upload_before
    }
  }
},
computed: {
    ...mapGetters(['allTemplateDetails', 'getUserDetails', 'getBatchTypesForStatus']),
    batchTypes: {
      get() {
        return this.$store.getters.getBatchTypesForStatus
      },
      set(batchTypes) {
        this.$store.commit('setBatchTypesForStatus', batchTypes)
      }
    },
    batchStatus: {
      get() {
        return this.$store.getters.getBatchStatus
      }
    },
    batchStatuses: {
      get() {
        return this.$store.getters.getBatchStatuses
      },
      set(batchStatuses) {
        this.$store.commit('setBatchStatuses', batchStatuses)
      }
    },
    datePickerFormat: {
      get() {
        if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
          let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
          return dateformat
        } else {
          return "DD-MM-YYYY"
        }
      }
    },
    batchRefTrim: {
      get() {
        return this.$store.getters.allTemplateDetails.batchRefTrim
      }
    },
    date_from() {
      return this.batchListRequest.upload_after
    }
},
watch: {
    date_from(date) {
      if(date){
        let dateFrom = moment(date, this.datePickerFormat)
        this.datePickerBeforeConfig.minDate = dateFrom
      }else{
        this.datePickerBeforeConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
      }
    },
    perPage() {
      if(this.batchListRequest.per_page !== this.perPage) {
        this.batchListRequest.per_page = this.perPage
        this.requestBatchStatus()
      }
    },
    statusListFilter(filter) {
      this.filterList(filter, 'status')
    },
    typeListFilter(filter) {
      this.filterList(filter, 'type')
    }
},
methods: {
  onFiltered(filteredItems) {
    this.filteredRows = filteredItems.length
    this.currentPage = 1
  },
  manualPagination(newPage) {
    let page = parseInt(newPage)
    if(this.batchListRequest.page !== page) {
      this.batchListRequest.page = page
      this.requestBatchStatus()
    }
    if(this.batchListRequest.page != this.$refs.paginationStartTop.currentPage) {
      this.$refs.paginationStartTop.currentPage = this.batchListRequest.page
    }
    if(this.batchListRequest.page != this.$refs.paginationStartBottom.currentPage) {
      this.$refs.paginationStartBottom.currentPage = this.batchListRequest.page
    }
    if(this.batchListRequest.page != this.$refs.paginationFinalTop.currentPage) {
      this.$refs.paginationFinalTop.currentPage = this.batchListRequest.page
    }
    if(this.batchListRequest.page != this.$refs.paginationFinalBottom.currentPage) {
      this.$refs.paginationFinalBottom.currentPage = this.batchListRequest.page
    }
  },
  resetSearch() {
    Object.keys(this.batchListRequest).forEach((key) => (this.batchListRequest[key] = undefined))
    this.batch_status = []
    this.batch_type = []
  },
  selectAllVisibleFiltersInList(filterListType) {
    if(filterListType == 'status') {
      //First we collect all currently visible batch statuses
      let statusList = document.getElementsByClassName('status-item')
      let visibleStatuses = []
      Object.keys(statusList).forEach(
        (key) => (
          //we have to select the first child of the visible batch status element divs (the checkbox)
          //and it's value will be our batch status
          (statusList[key].style.display !== 'none') && (visibleStatuses.push(statusList[key].firstChild.value))
        )
      )
      //if types had been selected before, we copy them
      let statuses = [... this.batch_status]
      Object.keys(this.batchStatuses).forEach(
        (key) => (
          (visibleStatuses.includes(this.batchStatuses[key].status)) && (statuses.push(this.batchStatuses[key].status))
        )
      )
      //turning our collection into a set removes all duplicates
      statuses = new Set(statuses)
      //turning our set back to an array and copying it's values to our query at the same time
      this.batch_status = [... statuses]
    } else {
      //First we collect all currently visible batch type element divs
      let typeList = document.getElementsByClassName('type-item')
      let visibleTypes = []
      Object.keys(typeList).forEach(
        (key) => (
          //we have to select the first child of the visible batch type element divs (the checkbox)
          //and it's value will be our batch type id
          (typeList[key].style.display !== 'none') && (visibleTypes.push(parseInt(typeList[key].firstChild.value)))
        )
      )
      //if types had been selected before, we copy them
      let types = [... this.batch_type]
      Object.keys(this.batchTypes).forEach(
        (key) => (
          (visibleTypes.includes(this.batchTypes[key].id)) && (types.push(this.batchTypes[key].id))
        )
      )
      //turning our collection into a set removes all duplicates
      types = new Set(types)
      //turning our set back to an array and copying it's values to our query at the same time
      this.batch_type = [... types]
    }
  },
  deselectVisibleFilterList(filterListType) {
    if(filterListType == 'status') {
      //First we collect all currently visible batch statuses
      let statusList = document.getElementsByClassName('status-item')
      let visibleStatuses = []
      Object.keys(statusList).forEach(
        (key) => (
          //we have to select the first child of the visible batch status element divs (the checkbox)
          //and it's value will be our batch status
          (statusList[key].style.display !== 'none') && (visibleStatuses.push(statusList[key].firstChild.value))
        )
      )
      //we make a copy of the currently selected statuses
      let statuses = [... this.batch_status]
      //we create an array of removeable statuses by filtering out the visible selected statuses
      let removeable = visibleStatuses.filter(status => statuses.includes(status))
      //we create our final array by filtering out the removeable statuses from the selection array
      let toKeep = statuses.filter(status => !removeable.includes(status))
      //we reset the selected statuses with the ones with want to keep
      this.batch_status = [... toKeep]
    } else {
      //First we collect all currently visible batch types
      let typeList = document.getElementsByClassName('type-item')
      let visibleTypes = []
      Object.keys(typeList).forEach(
        (key) => (
          //we have to select the first child of the visible batch type element divs (the checkbox)
          //and it's value will be our batch type id
          (typeList[key].style.display !== 'none') && (visibleTypes.push(parseInt(typeList[key].firstChild.value)))
        )
      )
      //we make a copy of the currently selected types
      let batchTypes = [... this.batch_type]
      //we create an array of removeable types by filtering out the visible selected types
      let removeable = visibleTypes.filter(type => batchTypes.includes(type))
      //let removeable = visibleTypes.filter( (type, batchTypes) => ((batchTypes.includes(type.toString() ) )) )
      //we create our final array by filtering out the removeable types from the selection array
      let toKeep = batchTypes.filter(type => !removeable.includes(type))
      //we reset the selected types with the ones with want to keep
      this.batch_type = [... toKeep]
    }
  },
  filterList(filter, filterListType) {
    if(filterListType == 'status') {
      let statusList = document.getElementsByClassName('status-item')
      let matches = []
      let lowerCase = filter.toLowerCase()
      //we collect matching elements
      Object.keys(statusList).forEach(
        (key) => (
          (statusList[key].firstChild.value.toLowerCase().includes(lowerCase)) && (matches.push(statusList[key]))
        )
      )

      //if the array of matching elements does not contain our element, we don't display it
      Object.keys(statusList).forEach((key) => ((!matches.includes(statusList[key]))) && (statusList[key].setAttribute('style', 'display:none;')))
      //if the array of matching elements contain our element, we restore it's display value
      Object.keys(statusList).forEach((key) => ((matches.includes(statusList[key]))) && (statusList[key].setAttribute('style', 'display:inline-flex;')))
    } else {
      let typesList = document.getElementsByClassName('type-item')
      let matches = []
      let lowerCase = filter.toLowerCase()
      //we collect matching elements
      Object.keys(typesList).forEach(
        (key) => (
          (typesList[key].textContent.toLowerCase().includes(lowerCase)) && (matches.push(typesList[key]))
        )
      )

      //if the array of matching elements does not contain our element, we don't display it
      Object.keys(typesList).forEach((key) => ((!matches.includes(typesList[key]))) && (typesList[key].setAttribute('style', 'display:none;')))
      //if the array of matching elements contain our element, we restore it's display value
      Object.keys(typesList).forEach((key) => ((matches.includes(typesList[key]))) && (typesList[key].setAttribute('style', 'display:inline-flex;')))
    }
  },
  routeBackToManageBatches() {
    this.$router.push({ name: 'manage_batches' })
  },
  requestBatchStatus() {
    this.isBusy = true
    Object.keys(this.batchListRequest).forEach((key) => ((this.batchListRequest[key] == '') || (this.batchListRequest[key] == null)) && (this.batchListRequest[key] = undefined))

    this.$router.push({ query: { ...this.$route.query, page: this.batchListRequest.page , per_page: this.batchListRequest.per_page, ...this.batchListRequest } })
    if(this.batch_type && (this.batch_type[0] !== '')){
      this.$router.push({ query: { ...this.$route.query, batch_type: this.batch_type} })
    }
    if(this.batch_status && (this.batch_status[0] !== '')){
      this.$router.push({ query: { ...this.$route.query, batch_status: this.batch_status} })
    }

    this.$store.dispatch('getBatchStatus', {
      page: this.batchListRequest.page,
      per_page: this.batchListRequest.per_page,
      batch_id: this.$route.query.batch_id,
      batch_ref: this.$route.query.batch_ref,
      batch_type: this.$route.query.batch_type,
      batch_status: this.$route.query.batch_status,
      upload_after : this.$route.query.upload_after,
      upload_before : this.$route.query.upload_before
    })
    .then(() => {
      this.isBusy = false

      //if we try to access a page that has no entries because it's after the last page
      //we set the pagination back to default and fetch the batches with the correct pagination
      if(this.batchStatus.current_page > this.batchStatus.last_page) {
        this.batchListRequest.page = 1
        this.batchListRequest.per_page = 20
        this.requestBatchStatus()
      }

      this.totalRows = this.batchStatus.total

      //if the response is empty and not because of an incorrect pagination request
      if((this.batchStatus.data.items === undefined)||(this.batchStatus.data.items.length == 0)) {
        this.rowEmpty = true
      }
      let status = this.$store.getters.getBatchStatus
      this.items = status.data.items
      this.summary = status.data.summary

      //setting the table variables
      this.currentPage = parseInt(this.batchListRequest.page)
      this.perPage = parseInt(this.batchListRequest.per_page)
      //setting the pagination manually
      this.manualPagination(parseInt(this.batchListRequest.page))
    })
  },
  rowClass(item, type) {
    if( type == 'row-details') {
      return 'row-details-style'
    }else{
      return
    }
  },
},
created() {
  this.batchTypes = this.$store.dispatch('getBatchTypesForStatus')
  this.batchStatuses = this.$store.dispatch('getBatchStatuses')

  // initializing the datepicker's format
  this.datePickerAfterConfig.format = this.datePickerFormat
  this.datePickerBeforeConfig.format = this.datePickerFormat

  let todaysDate = moment(new Date(), this.datePickerFormat)
  this.datePickerAfterConfig.maxDate = todaysDate
  this.datePickerBeforeConfig.maxDate = todaysDate

  if(Object.keys(this.$route.query).length) {
    this.batchListRequest = Object.assign({}, this.$route.query)

    if(this.$route.query.page) {
      this.batchListRequest.page = parseInt(this.$route.query.page)
    } else {
      this.batchListRequest.page = 1
    }

    if(this.$route.query.per_page) {
      this.batchListRequest.per_page = parseInt(this.$route.query.per_page)
    } else {
      this.batchListRequest.per_page = 20
    }

    //since the query string gives us the batch type ids' as strings
    //we have to make sure we pass each id as a number for the query
    if(this.$route.query.batch_type) {
      if(Array.isArray(this.$route.query.batch_type)) {
        Object.keys(this.$route.query.batch_type).forEach(
          (key) => (
            ( this.batch_type.push(parseInt(this.$route.query.batch_type[key])))
          )
        )
      } else {
        this.batch_type.push(parseInt(this.$route.query.batch_type))
      }
    }
    //the batch status is always a string so there is no need to convert it
    if(this.$route.query.batch_status) {
      this.batch_status = this.$route.query.batch_status
    }

    this.requestBatchStatus()
  } else {
    if((this.batchListRequest.page == undefined) || (this.batchListRequest.page == null) || (this.batchListRequest.page == '')){
      this.batchListRequest.page = 1
    }
    if((this.batchListRequest.per_page == undefined) || (this.batchListRequest.per_page == null) || (this.batchListRequest.per_page == '')){
      this.batchListRequest.per_page = 20
    }
    this.requestBatchStatus()
  }
},
beforeDestroy() {
  this.items = []
  this.summary = {}
},
filters: {
  trimBatchReference: function(reference, batchRefTrim) {
    if (reference && reference !== '') {
      return reference.slice(0, batchRefTrim)
    }
  },
  humanReadable: function(date) {
    return moment(date).format('MMMM Do YYYY, h:mm:ss a')
  },
  clientDateFormat: function(date, datePickerFormat) {
    return moment(date).format(datePickerFormat + ' h:mm:ss')
  }
},
components: {
  SubStatus,
  Loading,
  datePicker
}
}
</script>

<style lang="css" scoped>
/*-----SEARCH BAR-----*/
.text-netsend-blue{
  color: #047bf8;
}
.batch-search-border{
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 10px;
}
#batchToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}
#batchToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.showhand{
  cursor: pointer;
}

#dropdown-status >>> ul{
  box-shadow: 0 0 1px rgba(15, 24, 33, 0.5),
  0 25px 65px rgba(15, 24, 33, 0.29);
}
.dropdown-withform{
  min-width: 250px;
}

.table-responsive{
  max-width: 90vw;
  margin: 0 auto;
}

.width-control{
   max-width: 90vw !important;
   margin: 0 auto;
}

/*-----Placeholder text centering-----*/
::-webkit-input-placeholder {
  text-align: center;
}
:-moz-placeholder { /* Firefox 18- */
  text-align: center;
}
::-moz-placeholder {  /* Firefox 19+ */
  text-align: center;
}
:-ms-input-placeholder {
  text-align: center;
}

div.table-responsive >>> table td.highlight-red{
  background-color: #ff8a80 !important;
}

div.table-responsive >>> table tr.row-details-style td{
  padding: 0;
  background-color: rgba(4, 123, 248, 0.2);
}
/*
div.table-responsive >>> table tr.row-details-style{
  -webkit-animation-name: example;
  -webkit-animation-duration: 1s;
  animation-name: example;
  animation-duration: 1s;
}*/

div.table-responsive >>> table td, div.table-responsive >>> table th{
  box-sizing: content-box !important;
  border-right: 0;
}
div.table-responsive >>> table td{
  border-bottom: 0;
}

div.table-responsive >>> table td:last-of-type, div.table-responsive >>> table th:last-of-type{
  border-right: 1px solid rgba(83, 101, 140, 0.33);
}

div.table-responsive >>> table td.standard-cell-width-small{
  padding: 12px !important;
  width: 100%;
  min-width: 80px !important;
  max-width: 80px !important;
}
div.table-responsive >>> table th.standard-th-width-small{
  padding: 12px !important;
  width: 100%;
  min-width: 80px !important;
  max-width: 80px !important;
}

div.table-responsive >>> table td.standard-cell-width-xl{
  padding: 12px !important;
  width: 100%;
  min-width: 400px !important;
  max-width: 400px !important;
}
div.table-responsive >>> table th.standard-th-width-xl{
  padding: 12px !important;
  width: 100%;
  min-width: 400px !important;
  max-width: 400px !important;
}

div.table-responsive >>> table tr.sticky-footer{
  background-color: #fff;
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  z-index: 2;
}
div.table-responsive >>> table tr.sticky-footer th{
  border-top: 1px solid rgba(83, 101, 140, 0.66);
  background-color: #fff;
  position: sticky;
  position: -webkit-sticky;
  bottom: 0;
  z-index: 2;
}

/* scrollbar for sub batches
.sub-batch{
  box-sizing: content-box !important;
  width: 100%;
  max-height: 400px;
  overflow-y: scroll;
}
*/
.sub-batch >>> table{
  box-sizing: content-box !important;
  width: 100% !important;
}
.sub-batch >>> table td:last-of-type{
  border-right: 0 !important;
}
.sub-batch >>> table td:first-of-type{
  border-left: 0 !important;
}

div.tab-pane >>> .table-height-fix .table-responsive{
  min-height: 600px;
  padding: 0;
  margin: 0;
}
/* Colour guide to sub batch statuses*/
.no-list-style{
  list-style-type: none;
}
.colour-sample{
  width: 15px;
  height: 15px;
  border: 1px solid rgba(83, 101, 140, 0.33);
}
.highlight-yellow{
  background-color: #FFF176 !important;
}
.highlight-green{
  background-color: #DCE775 !important;
}
.highlight-grey{
  background-color: #E0E0E0 !important;
}
.highlight-red{
  background-color: #E57373 !important;
}

</style>
